import React from 'react'

const Footer = () => {
  return (
    <div className='bg-black w-full h-10 dark:bg-white'>
       <p className='text-white text-center pt-2 dark:text-black'>Website made by <a href="https://www.instagram.com/karam_alhinnawi/" className='underline'>Karam Kassam Alhinnawi</a></p>
    </div>
  )
}

export default Footer